module.exports = __webpack_public_path__ + "img/低通100.398e8ad3.png";